import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	socialIcons: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(2)
	},
	icon: {
		"& svg path": {
			fill: "#FFFFFF"
		},
		"&:hover svg path": {
			fill: theme.palette.secondary.light
		}
	}
}));

export default styles;
